// import 'swiper/css/bundle'
// swiper core styles
import "swiper/css";
// modules styles
import "swiper/css/pagination";
import "swiper/css/navigation";

import Swiper from "swiper";
// import { Pagination, Navigation } from "swiper/modules";

class Slider {
  constructor() {
    this.comparisonTable()
  }

  comparisonTable = () => {
    const slides = document.querySelectorAll(".slider-comparison-table-items");

    slides.forEach(function (slider, index) {
      slider.classList.add("slider-comparison-table-items-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-pagination")[0]
      //   .classList.add("swiper-pagination-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-button-next")[0]
      //   .classList.add("swiper-button-next-" + index);
      // slider.parentElement
      //   .getElementsByClassName("swiper-button-prev")[0]
      //   .classList.add("swiper-button-prev-" + index);

      // console.log(slider.getElementsByClassName('swiper-pagination')[0])

      new Swiper(".slider-comparison-table-items-" + index, {
        // modules: [Pagination, Navigation],
        // autoHeight: true,
        slidesPerView: 1.2,
        loop: false,
        spaceBetween: 0,
        // pagination: {
        //   el: ".swiper-pagination-" + index,
        //   clickable: true
        // },
        // navigation: {
        //   nextEl: ".swiper-button-next-" + index,
        //   prevEl: ".swiper-button-prev-" + index
        // },
        // Responsive breakpoints
        breakpoints: {
          768: {
            slidesPerView: 2,
            // spaceBetween: 24
          },
          // 992: {
          //   slidesPerView: 3
          // },
        }
      });
    });
  }

  // heroSlider() {
  // 	$(".slider-home-hero").each(function(index, element){
  // 		$(this).addClass("slider-home-hero-" + index)

  // 		let speed = $(this).data('speed'),
  // 				autoplay_delay = $(this).data('autoplay_delay')

  // 		new Swiper(".slider-home-hero-" + index, {
  // 			modules: [Autoplay],
  // 			slidesPerView: 1,
  // 			spaceBetween: 60,
  // 			loop: true,
  // 			speed: speed,
  // 			autoplay: {
  // 				delay: autoplay_delay,
  // 				disableOnInteraction: false,
  // 			},
  // 		})
  // 	})
  // }
}

new Slider
